import { render, staticRenderFns } from "./FormInputField.vue?vue&type=template&id=01683a60&"
import script from "./FormInputField.vue?vue&type=script&lang=js&"
export * from "./FormInputField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports